/*============================================================================
  HC - IB brand text helpers - 2026-10-01

  How brand names sort and match a search, in one place for the desktop
  BRANDS menu (assets/ib-brands-menu.js) and the promotions page's brand
  filter (assets/shoppable-promotions.js). Moved here from the desktop menu
  unchanged. The mobile menu, the brands page, the categories page and the
  collection filters still keep their own copies;
  tests/brands-menu/source.test.js checks the mobile menu's agree with these.

  Loaded by layout/theme.liquid before ib-brands-menu.js (with
  settings.brands_menu_v2) and by sections/shoppable-promotions.liquid
  before its engine, whatever the menu setting. Both can load it on one
  page, so a second run keeps the first copy. ES5 on purpose (no build
  step).
==============================================================================*/
(function () {
  'use strict';

  if (window.IBBrandText) return;

  // "L'Oreal" -> "loreal", "äz" -> "az", "milk_shake" -> "milkshake",
  // "It's a 10" -> "its a 10". Diacritics are stripped via NFD when available.
  function normalizeText(value) {
    var s = value === null || value === undefined ? '' : String(value);
    if (typeof s.normalize === 'function') {
      s = s.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }
    s = s.toLowerCase();
    s = s.replace(/&amp;/g, ' ');
    s = s.replace(/[^a-z0-9 ]+/g, '');
    s = s.replace(/\s+/g, ' ').replace(/^ | $/g, '');
    return s;
  }

  function brandSortKey(title) {
    return normalizeText(title);
  }

  function letterFor(key) {
    var c = String(key || '').charAt(0);
    return /[a-z]/.test(c) ? c.toUpperCase() : '#';
  }

  // Both arguments are already normalized. Empty query matches everything.
  function matchesQuery(normTitle, normQuery) {
    var title = String(normTitle || '');
    var query = String(normQuery || '');
    if (!query) return true;
    if (title.indexOf(query) !== -1) return true;
    var squashedTitle = title.replace(/ /g, '');
    var squashedQuery = query.replace(/ /g, '');
    if (squashedQuery && squashedTitle.indexOf(squashedQuery) !== -1) return true;
    var words = title.split(' ');
    for (var i = 0; i < words.length; i++) {
      if (words[i].indexOf(query) === 0) return true;
    }
    return false;
  }

  // How well a normalized title matches, for ordering search results: 0 when
  // the name starts with the query, 1 when a later word does, 2 otherwise.
  // Only meaningful for titles matchesQuery already accepted. The mobile menu
  // lists its matches A-Z instead.
  function matchRank(normTitle, normQuery) {
    var title = String(normTitle || '');
    var query = String(normQuery || '');
    if (!query || title.indexOf(query) === 0) return 0;
    var words = title.split(' ');
    for (var i = 1; i < words.length; i++) {
      if (words[i].indexOf(query) === 0) return 1;
    }
    return 2;
  }

  function compareKeys(a, b) {
    var la = letterFor(a);
    var lb = letterFor(b);
    if (la === '#' && lb !== '#') return 1;
    if (lb === '#' && la !== '#') return -1;
    if (typeof a.localeCompare === 'function') {
      try {
        return a.localeCompare(b, 'en', { sensitivity: 'base', numeric: true });
      } catch (e) {
        /* fall through */
      }
    }
    if (a < b) return -1;
    if (a > b) return 1;
    return 0;
  }

  // items: [{ title, href, key?, el? }]. Returns a new array, sorted by key
  // ('#' bucket last) and deduped by href (first occurrence wins). Stable.
  function sortBrands(items) {
    var seen = {};
    var out = [];
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (!item) continue;
      var href = item.href || '';
      if (href && seen[href]) continue;
      if (href) seen[href] = true;
      var key = item.key || brandSortKey(item.title);
      out.push({ item: item, key: key, index: i });
    }
    out.sort(function (a, b) {
      var c = compareKeys(a.key, b.key);
      return c !== 0 ? c : a.index - b.index;
    });
    var result = [];
    for (var j = 0; j < out.length; j++) {
      var entry = out[j].item;
      entry.key = out[j].key;
      result.push(entry);
    }
    return result;
  }

  // sorted: output of sortBrands. Returns [{ letter, items }], '#' last.
  function groupByLetter(sorted) {
    var groups = [];
    var byLetter = {};
    for (var i = 0; i < sorted.length; i++) {
      var item = sorted[i];
      var letter = letterFor(item.key || brandSortKey(item.title));
      if (!byLetter[letter]) {
        byLetter[letter] = { letter: letter, items: [] };
        groups.push(byLetter[letter]);
      }
      byLetter[letter].items.push(item);
    }
    groups.sort(function (a, b) {
      if (a.letter === '#') return 1;
      if (b.letter === '#') return -1;
      return a.letter < b.letter ? -1 : a.letter > b.letter ? 1 : 0;
    });
    return groups;
  }

  window.IBBrandText = {
    normalizeText: normalizeText,
    brandSortKey: brandSortKey,
    letterFor: letterFor,
    matchesQuery: matchesQuery,
    matchRank: matchRank,
    compareKeys: compareKeys,
    sortBrands: sortBrands,
    groupByLetter: groupByLetter
  };
})();
